import { toast } from 'sonner';

import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';

import { isAiProviderError } from '../errors';
import { useSetDefaultAiProvider } from '../hooks/useSetDefaultAiProvider';
import type { AiProvider } from '../types';

/**
 * Shows the "Default" badge on the default provider, or a "Set as default"
 * action on every other provider (spec FR-009a).
 */
export function SetDefaultProviderControl({
  provider,
}: {
  provider: AiProvider;
}) {
  const setDefault = useSetDefaultAiProvider();

  if (provider.is_default) {
    return <Badge>Default</Badge>;
  }

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      disabled={setDefault.isPending}
      onClick={() => {
        setDefault.mutate(provider.id, {
          onError: (error) => {
            toast.error(
              isAiProviderError(error)
                ? error.message
                : 'Could not set this provider as default. Please try again.',
            );
          },
        });
      }}
    >
      Set as default
    </Button>
  );
}
